import { FC } from "react"
import { PriceVsSalesItem } from "../../../app/reducers/analyticsSlice"
import { HBarChart } from "../charts/HBarChart"
import { fmtRub, fmtPct } from "../utils/formatters"
import { DataTable, type DataTableColumn } from "../../DataTable/DataTable"

type PriceVsSalesSectionProps = { items: PriceVsSalesItem[] }

type PriceVsSalesRow = PriceVsSalesItem & { _index: number }

const columns: DataTableColumn<PriceVsSalesRow>[] = [
  { key: "_index", header: "#", cell: (row) => row._index },
  {
    key: "article",
    header: "Артикул",
    cell: (item) =>
      item.article.length > 40 ? item.article.slice(0, 40) + "…" : item.article,
  },
  { key: "name", header: "Категория" },
  {
    key: "avgPrice",
    header: "Ср. цена",
    cell: (item) => fmtRub(item.avgPrice),
  },
  {
    key: "avgCost",
    header: "Ср. себест.",
    cell: (item) => (item.avgCost > 0 ? fmtRub(item.avgCost) : "—"),
    cellStyle: (item) => ({
      color: item.avgCost > 0 ? "inherit" : "var(--gray-7)",
    }),
  },
  { key: "salesCount", header: "Продажи (шт)" },
  { key: "revenue", header: "Выручка", cell: (item) => fmtRub(item.revenue) },
  {
    key: "profit",
    header: "Прибыль",
    cell: (item) => (item.avgCost > 0 ? fmtRub(item.profit) : "—"),
    cellStyle: (item) => ({
      color:
        item.avgCost > 0
          ? item.profit >= 0
            ? "#1a7f44"
            : "#c92a2a"
          : "var(--gray-7)",
      fontWeight: item.avgCost > 0 ? 600 : 400,
    }),
  },
  {
    key: "margin",
    header: "Маржа",
    cell: (item) => (item.avgCost > 0 ? fmtPct(item.margin) : "—"),
    cellStyle: (item) => ({
      color:
        item.avgCost > 0
          ? item.margin > 20
            ? "#1a7f44"
            : item.margin > 0
            ? "#865900"
            : "#c92a2a"
          : "var(--gray-7)",
    }),
  },
]

export const PriceVsSalesSection: FC<PriceVsSalesSectionProps> = ({
  items,
}) => {
  const maxSales = Math.max(...items.map((i) => i.salesCount), 1)

  return (
    <div className="chart-wrap">
      <div className="chart-title">Цена vs Продажи (top-50)</div>
      <div style={{ marginBottom: 18 }}>
        <HBarChart
          items={items.slice(0, 30).map((i) => ({
            label:
              i.article.length > 25 ? i.article.slice(0, 25) + "…" : i.article,
            value: i.salesCount,
            color: "#1971c2",
          }))}
          maxValue={maxSales}
        />
      </div>
      <div className="analytics-table-wrap">
        <DataTable
          columns={columns}
          data={items.map((item, i) => ({ ...item, _index: i + 1 }))}
          rowKey={(item) => item.nmId}
          variant="ghost"
          size="2"
        />
      </div>
    </div>
  )
}
